import MarkdownIt from 'markdown-it';

/**
 * Markdown of the v2 text component, shared by the dashboard and the Studio preview. Unlike MarkdownExtension
 * it lets no HTML through: the text is authored in the dashboard JSON and shown to every viewer.
 */
const md = new MarkdownIt({html: false, linkify: false, typographer: false});

// Not part of the feature, and a channel for tracking pixels and external loads
md.disable(['image']);

// An allowlist instead of markdown-it's blacklist: also blocks data:, vbscript: and protocol-relative //host
md.validateLink = (url: string): boolean => /^(https?:|mailto:|#|\/(?!\/))/i.test(url.trim());

const ALIGN_CLASSES: Record<string, string> = {left: 'text-start', center: 'text-center', right: 'text-end'};

/** Adjusts the token's attributes, then renders it the default way. */
const withToken = (adjust: (token: MarkdownIt.Token) => void): MarkdownIt.Renderer.RenderRule =>
    (tokens, idx, options, _env, self) => {
        adjust(tokens[idx]);
        return self.renderToken(tokens, idx, options);
    };

/** markdown-it aligns table cells with an inline style; a class keeps the output free of style attributes. */
const alignToClass = withToken(token => {
    const align = /text-align:\s*(left|center|right)/.exec(token.attrGet('style') ?? '')?.[1];
    token.attrs = (token.attrs ?? []).filter(([name]) => name !== 'style');
    if (align) {
        token.attrJoin('class', ALIGN_CLASSES[align]);
    }
});

md.renderer.rules.th_open = alignToClass;
md.renderer.rules.td_open = alignToClass;
md.renderer.rules.table_open = withToken(token => token.attrJoin('class', 'table table-sm'));
md.renderer.rules.link_open = withToken(token => {
    if (/^https?:/i.test(token.attrGet('href') ?? '')) {
        token.attrSet('target', '_blank');
        token.attrSet('rel', 'noopener noreferrer');
    }
});

export function renderMarkdown(source: string): string {
    return md.render(source);
}
